import React from "react";
import Food from "./Food";
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import NoSearchResults from "./NoSearchResults";
import { GetResourceVenueId } from '@switch/core';
import { useWidgetContext } from "../widgetContext";

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        overflow: 'hidden',
        backgroundColor: theme.palette.background.paper,
    },
    gridList: {
        width: 'auto',
        height: 'auto',
    },
    icon: {
        color: 'rgba(255, 255, 255, 0.54)',
    },
}));

export const FoodListTakeAway = ({ courseId, menuDetails, setMenuDetails, food, addBookingDetail, removeBookingDetail }) => {
    const classes = useStyles();
    const context = useWidgetContext();
    if (!food) return null;


    if (food.length === 0) {
        return (
            <NoSearchResults title={"switch.widget.notfound.nofood"} classes={classes} />
        );
    }
    return (
        <Grid container direction="row" justify="space-evenly" alignItems="center" spacing={4}>
            {food.map(item => {

                const venueId = GetResourceVenueId(food, context?.bookingRequest?.venueId)

                return (
                <Grid item xs={12} key={item.id}>
                    <Food key={item.id} courseId={courseId} menuDetails={menuDetails} setMenuDetails={setMenuDetails} isTakeAway={true} 
                            food={item} onAdd={() => addBookingDetail(menuDetails.resourceId, venueId, undefined, menuDetails, courseId, item.id)} 
                            onRemove={() => removeBookingDetail(item.id, venueId)} />
                </Grid>);
            })}
        </Grid>
    );
};

export default FoodListTakeAway;
